
export const Specialties = () => {
    return(
        <h1>Specialties</h1>
    )
};